import withLazyLoading from '../../hoc/withLazyLoading';
import { validatePermission, createCrumbHandle } from '../../utilities/auth';

const WorkspaceListPage = withLazyLoading(
  () => import('../../pages/workspace-management/component/WorkspaceListPage')
);
const WorkspaceCreatePage = withLazyLoading(
  () => import('../../pages/workspace-management/component/WorkspaceCreatePage')
);
const WorkspaceConfig = withLazyLoading(() => import('../../pages/WorkspaceConfig'));
const WorkspaceConfigList = withLazyLoading(() => import('../../pages/WorkspaceConfigList'));

const workspaceRoutes = [
  {
    path: '/workspaceList',
    handle: createCrumbHandle('Workspaces'),
    children: [
        {
            index: true,
            element: <WorkspaceListPage />,
            loader: validatePermission('Workspace_View_R'),
        },
        {
            path: 'createWorkspace/:id',
            element: <WorkspaceCreatePage />,
            loader: validatePermission('Workspace_Manage_A'),
            handle: createCrumbHandle('Create Workspace'),
          },
          {
            path: 'editWorkspace/:id',
            element: <WorkspaceCreatePage />,
            loader: validatePermission('Workspace_Configuration_WE'),
            handle: createCrumbHandle('Edit Workspace'),
          },
    ]
  },
  {
    path: '/WorkspaceConfig/:workspaceId',
    element: <WorkspaceConfig />,
    loader: validatePermission('Workspace_Configuration_WE'),
    handle: createCrumbHandle('Workspace Configuration'),
  },
  {
    path: '/WorkspaceConfigList',
    element: <WorkspaceConfigList />,
    loader: validatePermission('Workspace_View_R'),
    handle: createCrumbHandle('Workspaces'),
  },
];

export default workspaceRoutes;
